import type { DevToolboxScenario, DevToolboxScenarioId } from "./types";

/** Production stub — real runtime is dev-only (see next.config.mjs alias). */
export const getActiveDevToolboxScenarioId = (): DevToolboxScenarioId | null =>
  null;

export const getActiveDevToolboxScenario = (): DevToolboxScenario | null =>
  null;

export const setActiveDevToolboxScenario = (
  _scenarioId: DevToolboxScenarioId,
): void => {};

export const clearActiveDevToolboxScenario = (): void => {};

export const getFavoriteScenarioIds = (): DevToolboxScenarioId[] => [];

export const isFavoriteScenario = (
  _scenarioId: DevToolboxScenarioId,
): boolean => false;

export const toggleFavoriteScenarioId = (
  scenarioId: DevToolboxScenarioId,
): DevToolboxScenarioId[] => [scenarioId];

export const subscribeToDevToolboxScenario =
  (_listener: () => void): (() => void) =>
  () => {};

export const sioDevToolboxCatalog = {
  list: () => [] as DevToolboxScenario[],
  get: (_id: string) => undefined as DevToolboxScenario | undefined,
  has: (_id: string) => false,
  register: (_scenarios: readonly DevToolboxScenario[]) => {},
};
